import type {
  PostDocumentNotesRequestType,
  PostDocumentNotesResponseType,
} from 'entities/document/api/types';
import { apiAuthClient } from 'shared/api/lib/apiAuthClient';

export const postDocumentsNotes = async (
  params: PostDocumentNotesRequestType,
) => {
  const url = `/document/${params.documentId}/notes`;
  const response = await apiAuthClient.post<PostDocumentNotesResponseType>(
    url,
    params.body,
  );

  return response.data;
};
